import React from 'react';

const FAQ = () => (<div id="faq" style={{marginTop: '75px'}}>
  <div>
    <h3 className="bold">FAQ</h3>
    <div className="ms-3 me-3 mt-5">
      <h5 className="bold mt-5 mb-4">Do you support WordPress or similar CMS?</h5>
      <p>
        No we do not, we only host static websites.
      </p>
      <h5 className="bold mt-5 mb-4">What is a static website?</h5>
      <p>
        A static website is a website that appears the same to all visitors and does not require a backend server or database to render it. It's composed of frontend only static files such as such as HTML, JavaScript and images (jpeg, png, svg etc).
      </p>
      <h5 className="bold mt-5 mb-4">Do you support e-commerce sites?</h5>
      <p>
        We do not in the traditional CMS way (WordPress, Joomla etc), but we do support static e-commerce sites.
      </p>
      <h5 className="bold mt-5 mb-4">How can I delete my site?</h5>
      <p>
        You can delete your site or account from your control panel.
      </p>
      <h5 className="bold mt-5 mb-4">Who owns the copyright?</h5>
      <p>
        You own the copyright for all uploaded content, we do not claim any rights except to publicly
        serve it. You are responsible for the licenses and copyright of any uploaded material.
      </p>
      <h5 className="bold mt-5 mb-4">What can I upload?</h5>
      <p>
        You can upload a zip file containing folders and any static files such as HTML, JavaScript, images, css
        etc
        linked by an index.html. Your zip must include an index.html file.
      </p>
    </div>
  </div>
</div>);

export default FAQ;
